import {
  INTERNAL_MINDSEA_EMAIL_DOMAIN,
  INTERNAL_POINTCARE_EMAIL_DOMAIN,
} from "@/domain/constants";
import { envVariables } from "@/utils/envVariables";

/**
 * DEV tooling (e.g. the dashboard scenario panel) is never available in
 * production. Non-production alone is not sufficient — staging is also reachable
 * by external users — so callers additionally gate on an internal staff email
 * via `isInternalStaffEmail` (see `useIsDevToolsEnabled`).
 */
export const isNonProductionEnv =
  envVariables.EXPO_PUBLIC_ENVIRONMENT !== "production";

const INTERNAL_EMAIL_DOMAINS = [
  INTERNAL_MINDSEA_EMAIL_DOMAIN,
  INTERNAL_POINTCARE_EMAIL_DOMAIN,
];

/** Whether an email belongs to an internal staff domain (@mindsea / @pointcare). */
export const isInternalStaffEmail = (
  email: string | null | undefined,
): boolean => {
  if (!email) return false;
  const normalized = email.toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.some(domain => normalized.endsWith(domain));
};
